{
  "pages": {
    "Login": {
      "attrs": {
        "singapore": "Malaysia",
        "pomelo": "Maybank",
        "simonverraestsiamtradingth": "simon.verraest@bilabila.co"
      },
      "powering_singapores_digital_commerce": "Powering Malaysia's Digital Commerce",
      "the_complete_payment_solution_for_modern": "The complete payment solution for modern merchants. Manage\n              transactions, track settlements, and grow your business with\n              confidence.",
      "merchant_portal": "Merchant Portal",
      "sign_in_to_manage_your_business": "Sign in to manage your business payments",
      "email_address": "Email Address",
      "password": "Password",
      "remember_me": "Remember me",
      "forgot_password": "Forgot password?",
      "sign_in": "Sign In",
      "dont_have_a_merchant_account": "Don't have a merchant account?",
      "contact_sales": "Contact Sales",
      "back_to_sign_in": "Back to sign in",
      "check_your_email": "Check your email",
      "weve_sent_a_6digit_verification_code": "We've sent a 6-digit verification code to",
      "enter_verification_code": "Enter verification code",
      "verify_sign_in": "Verify & Sign In",
      "didnt_receive_the_code": "Didn't receive the code?",
      "resend_in": "Resend in",
      "s": "s",
      "resend_code": "Resend code",
      "for_your_security_this_code_expires": "For your security, this code expires in 10 minutes. If you\n                    didn't request this code, please secure your account\n                    immediately.",
      "2026_pomelo_pay_all_rights_reserved": "© 2026 Maybank. All rights reserved."
    }
  }
}